import List, { SkeletonListItems } from '@/components/List';
import FormSubmissionsListItem, {
  type FormSubmissionsListItemProps,
} from './FormSubmissionsListItem';

export type FormSubmissionsListProps = {
  isFetchingData?: boolean;
  className?: string;
  submissionIds: number[];
  onSelect: FormSubmissionsListItemProps['onSelect'];
};

export default function FormSubmissionsList({
  isFetchingData,
  className,
  submissionIds,
  onSelect,
}: FormSubmissionsListProps) {
  return (
    <List className={className}>
      {isFetchingData ? (
        <SkeletonListItems />
      ) : (
        submissionIds.map((id) => (
          <FormSubmissionsListItem
            key={id}
            submissionId={id}
            onSelect={onSelect}
          />
        ))
      )}
    </List>
  );
}
